var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "ap-modal-element" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.name,
            expression: "name"
          }
        ],
        staticClass: "cd-modal-text-input",
        attrs: { type: "text" },
        domProps: { value: _vm.name },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.name = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showAlert === "category_name",
              expression: "showAlert === 'category_name'"
            }
          ],
          staticClass: "form-alert-danger"
        },
        [_vm._v("\n            Обязательное поле!\n        ")]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ap-modal-title-medium" }, [
      _vm._v("\n        Название родительской категории:\n    ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ap-button-edit-category ap-modal-element",
        on: { click: _vm.selectCategory }
      },
      [
        _c("SVGAdminEditRow", { staticClass: "ap-button-edit-category-svg" }),
        _vm._v(" "),
        _c("div", { staticClass: "ap-button-edit-category-text" }, [
          _vm._v(_vm._s(_vm.parentCategory.name))
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-button", on: { click: _vm.apply } }, [
      _vm._v("\n        " + _vm._s(_vm.buttonName) + "\n    ")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ap-modal-input-name" }, [
      _vm._v("\n            Название "),
      _c("span", { staticClass: "red-text" }, [_vm._v("*")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }